import ProgixRefundSuccess from "../../../../components/units/Progix/RefundHistory/ProgixRefundSuccess";

export default function ProgixRefundHistoryPage() {
  return <ProgixRefundSuccess />;
}
